const navigation = document.querySelector('.js-navigation');

if (navigation) {
    if ( window.innerWidth <= 1150 ) {
        const toggleButtons = document.querySelectorAll('.js-navigationToggle');
        const navigation = document.querySelector('.js-navigation');
        const dim = document.querySelector('.js-dim');
        const body = document.querySelector('body');
        // Only attach to top-level items, not nested left-column items
        const menuItemsWithChildren = document.querySelectorAll('.js-navigation > li.menu-item-has-children');

        toggleButtons.forEach(button => {
            button.addEventListener('click', function () {
                const isOpen = navigation.classList.toggle('-open');
                body.classList.toggle('-menuOpen', isOpen);
                dim.classList.toggle('-active', isOpen);
                if (isOpen) {
                    requestAnimationFrame(() => navigation.focus());
                }
            });
        });

        menuItemsWithChildren.forEach(menuItem => {
            menuItem.addEventListener('click', function (e) {
                // e.preventDefault();
                const isOpen = menuItem.classList.toggle('-open');
                const subMenu = menuItem.querySelector('.sub-menu');
                if (subMenu) {
                    subMenu.classList.toggle('-open', isOpen);
                    if (!isOpen) {
                        // Reset two-column state when closing a top-level item
                        subMenu.classList.remove('-rightOpen');
                        const right = subMenu.querySelector('.js-navigationItemsRight');
                        if (right) {
                            right.querySelectorAll('ul.sub-menu').forEach((p) => p.classList.remove('-active'));
                        }
                        const left = subMenu.querySelector('.js-navigationItemsLeft');
                        if (left) {
                            left.querySelectorAll('li').forEach((li) => li.classList.remove('-active'));
                        }
                    }
                }
            });
        });

        // Two-column submenu mapping on mobile: click left item to show matching right panel by ID
        const leftContainers = navigation.querySelectorAll('.js-navigationItemsLeft');
        leftContainers.forEach((leftContainer) => {
            const subMenuContainer = leftContainer.parentElement; // ul.sub-menu
            const rightContainer = subMenuContainer ? subMenuContainer.querySelector('.js-navigationItemsRight') : null;
            if (!rightContainer) { return; }

            const leftItems = Array.from(leftContainer.querySelectorAll('li'));
            const rightPanels = Array.from(rightContainer.querySelectorAll('ul.sub-menu'));

            const getIdFromMenuItem = (el) => {
                for (const cls of el.classList) {
                    const m = cls.match(/^menu-item-(\d+)$/);
                    if (m) return m[1];
                }
                return null;
            };

            const showPanelForId = (id) => {
                rightPanels.forEach((panel) => {
                    const shouldShow = panel.classList.contains(`sub-menu-for-item-${id}`);
                    panel.classList.toggle('-active', shouldShow);
                });
                leftItems.forEach((item) => {
                    const itemId = getIdFromMenuItem(item);
                    item.classList.toggle('-active', itemId === id);
                });
            };

            // Wire up the back button rendered in PHP
            const backButton = rightContainer.querySelector('.js-navigationBack');
            if (backButton) {
                backButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    subMenuContainer.classList.remove('-rightOpen');
                    rightPanels.forEach((p) => p.classList.remove('-active'));
                    leftItems.forEach((li) => li.classList.remove('-active'));
                });
            }

            // Hide all right panels initially
            rightPanels.forEach((panel) => panel.classList.remove('-active'));

            leftItems.forEach((item) => {
                item.addEventListener('click', (e) => {
                    const id = getIdFromMenuItem(item);
                    if (!id) { return; }
                    const panel = rightContainer.querySelector(`.sub-menu-for-item-${id}`);
                    if (!panel) {
                        // Clear active states and allow navigation
                        rightPanels.forEach((p) => p.classList.remove('-active'));
                        leftItems.forEach((li) => li.classList.remove('-active'));
                        return;
                    }

                    const isAlreadyActive = item.classList.contains('-active') && panel.classList.contains('-active');
                    if (isAlreadyActive) {
                        // Toggle off
                        e.preventDefault();
                        e.stopPropagation();
                        rightPanels.forEach((p) => p.classList.remove('-active'));
                        leftItems.forEach((li) => li.classList.remove('-active'));
                        subMenuContainer.classList.remove('-rightOpen');
                        return;
                    }

                    // Use click to reveal the mapped panel and prevent navigation
                    // e.preventDefault();
                    e.stopPropagation();
                    subMenuContainer.classList.add('-rightOpen');
                    showPanelForId(id);
                });
            });
        });
    } else {
        const leftContainer = navigation.querySelector('.js-navigationItemsLeft');
        const rightContainer = navigation.querySelector('.js-navigationItemsRight');
        if (leftContainer && rightContainer) {
            const leftItems = Array.from(leftContainer.querySelectorAll('li'));
            const rightPanels = Array.from(rightContainer.querySelectorAll('ul.sub-menu'));

            const getIdFromMenuItem = (el) => {
                for (const cls of el.classList) {
                    const m = cls.match(/^menu-item-(\d+)$/);
                    if (m) return m[1];
                }
                return null;
            };

            const showPanelForId = (id) => {
                rightPanels.forEach((panel) => {
                    const shouldShow = panel.classList.contains(`sub-menu-for-item-${id}`);
                    panel.classList.toggle('-active', shouldShow);
                });
                leftItems.forEach((item) => {
                    const itemId = getIdFromMenuItem(item);
                    item.classList.toggle('-active', itemId === id);
                });
            };

            // Hide all panels initially
            rightPanels.forEach((panel) => panel.classList.remove('-active'));

            leftItems.forEach((item) => {
                item.addEventListener('mouseenter', () => {
                    const id = getIdFromMenuItem(item);
                    if (!id) return;
                    const hasPanel = rightContainer.querySelector(`.sub-menu-for-item-${id}`);
                    if (!hasPanel) {
                        rightPanels.forEach((panel) => panel.classList.remove('-active'));
                        leftItems.forEach((li) => li.classList.remove('-active'));
                        return;
                    }
                    showPanelForId(id);
                });

                // Keyboard accessibility: focus shows panel
                item.addEventListener('focusin', () => {
                    const id = getIdFromMenuItem(item);
                    if (!id) return;
                    const hasPanel = rightContainer.querySelector(`.sub-menu-for-item-${id}`);
                    if (!hasPanel) return;
                    showPanelForId(id);
                });
            });

            // When exiting the submenu entirely, clear active state
            const parentLi = navigation.closest('li.menu-item-has-children');
            if (parentLi) {
                parentLi.addEventListener('mouseleave', () => {
                    rightPanels.forEach((panel) => panel.classList.remove('-active'));
                    leftItems.forEach((li) => li.classList.remove('-active'));
                });
            }
        }
    }
}